/*import React from 'react'

import { Form } from '_zari/core'

import * as SocioService from 'services/socio.service'

const TituloViaticoSelect = ({ idSocio, ...props }) => {
  const [titulosViaticos, setTitulosViaticos] = React.useState([])

  React.useEffect(() => {
    if (idSocio) {
      SocioService.obtenerTitulosViaticosxIdSocioAsSelect(idSocio).then(({ data }) => {
        setTitulosViaticos(data)
      })
    } else {
      setTitulosViaticos([])
    }
  }, [idSocio])

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {titulosViaticos.map((x, k) => (
        <option key={k} value={x._id}>
          {x.nombre}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(TituloViaticoSelect)
*/

import React from 'react'
import { Form } from '_zari/core'
import * as SocioService from 'services/socio.service'
import * as UsuarioService from 'services/usuario.service'

const TituloViaticoSelect = ({ idSocio, idUsuario, ...props }) => {
  const [titulosViaticos, setTitulosViaticos] = React.useState([])

  React.useEffect(() => {
    if (idSocio) {
      SocioService.obtenerTitulosViaticosxIdSocioAsSelect(idSocio).then(({ data }) => {
        setTitulosViaticos(data)
      })
    } else if (idUsuario) {
      UsuarioService.obtenerTitulosViaticosxIdUsuarioAsSelect(idUsuario).then(({ data }) => {
        setTitulosViaticos(data)
      })
    } else {
      setTitulosViaticos([])
    }
  }, [idSocio, idUsuario])

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {titulosViaticos.map((x, k) => (
        <option key={k} value={x._id}>
          {x.nombre}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(TituloViaticoSelect)
